module.exports = __webpack_public_path__ + "img/MongoDB.1e11fee.svg";